import React from 'react';
import './CollapsibleHelp.css';

/** Alleen toelichting/instructies — standaard ingeklapt, open via pijltje. Geen velden of knoppen hierin. */
export default function CollapsibleHelp({ title = 'Uitleg', children, className = '', defaultOpen = false }) {
  return (
    <details className={`collapsible-help ${className}`.trim()} open={defaultOpen ? true : undefined}>
      <summary className="collapsible-help-summary">{title}</summary>
      <div className="collapsible-help-body">{children}</div>
    </details>
  );
}
